export default "__VITE_ASSET__acc8cb55__"